import { render } from "./RegistrosTab.vue?vue&type=template&id=f9cb4ca2&scoped=true"
import script from "./RegistrosTab.vue?vue&type=script&lang=js"
export * from "./RegistrosTab.vue?vue&type=script&lang=js"

import "./RegistrosTab.vue?vue&type=style&index=0&id=f9cb4ca2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9cb4ca2"]])

export default __exports__